/**
 * The type of the camera transition:
 * - set : Hard switch
 * - flysmooth: TODO
 * - fade : Blackfade between the switch
 */
export var MovementMode;
(function (MovementMode) {
    MovementMode["set"] = "set";
    MovementMode["flysmooth"] = "flysmooth";
    MovementMode["fade"] = "fade";
})(MovementMode || (MovementMode = {}));
//# sourceMappingURL=movement-mode.js.map